export enum RATING_STYLE {
  STAR = 'star',
  SCORE = 'score'
}

export enum BUTTON_TYPE {
  regular = 'regular',
  icon = 'icon-only'
}
export type ProductCardPlacementType = 'product_card' | 'product_group' | 'comparison_table';
export type ProductCardTrackingType = {
  product_card_type: ProductCardPlacementType,
  product_card_position: string,
  product_card_rel_position: string
}
